import { LocalTime } from 'js-joda';
import { SelectFieldProps } from 'ui/SelectField';
import {
  getTimeFormatter,
  twentyFourHourFormatter,
  twentyFourHourNakedFormatter,
} from '@tock/i18n';
import { useAppContext } from '@tock/coretypes';
import FormSelectField from 'ui/FormSelectField';
import _ from 'lodash';

interface Props extends Pick<SelectFieldProps, Exclude<keyof SelectFieldProps, 'children'>> {
  includeNone?: boolean;
  incrementsInMinutes?: number;
  minLocalTimeInclusive: LocalTime; // First selectable time.
  maxLocalTimeInclusive: LocalTime; // Last selectable time.
  ['aria-label']?: string;
}

const FormTimeSelectField: React.FunctionComponent<Props> = ({
  includeNone,
  minLocalTimeInclusive,
  maxLocalTimeInclusive,
  incrementsInMinutes,
  ...props
}) => {
  const {
    context: { locale },
  } = useAppContext();

  const deltaMinutes = incrementsInMinutes || 15;
  const options: SelectOption[] = [];
  const adjustedStart = minLocalTimeInclusive.minusHours(4);
  const adjustedEnd = maxLocalTimeInclusive.minusHours(4);
  for (let t = adjustedStart; t.isBefore(adjustedEnd); t = t.plusMinutes(deltaMinutes)) {
    const timeToRender = t.plusHours(4);
    options.push({
      key: twentyFourHourNakedFormatter.format(timeToRender),
      label: getTimeFormatter(locale).format(timeToRender),
      value: twentyFourHourFormatter.format(timeToRender),
    });
  }
  //If the last time is 3:45, and adjusted is 23:45, adding 15 minutues gets you back to 0:00. Causing infinite loop
  options.push({
    key: twentyFourHourNakedFormatter.format(maxLocalTimeInclusive),
    label: getTimeFormatter(locale).format(maxLocalTimeInclusive),
    value: twentyFourHourFormatter.format(maxLocalTimeInclusive),
  });
  const selectOptions = includeNone
    ? _.concat(
        [
          {
            key: 'None',
            label: 'None',
            value: '',
          },
        ],
        options
      )
    : options;

  return (
    <FormSelectField disabled={false} {...props}>
      {selectOptions.map((selectOption) => (
        <option value={selectOption.value} key={selectOption.key} data-testid={selectOption.value}>
          {selectOption.label}
        </option>
      ))}
    </FormSelectField>
  );
};

export default FormTimeSelectField;
